import { Grid } from '@mui/material';
import PasswordInputField from './PasswordInputField';
import useMessages from 'hooks/useMessages';
import {
  changePasswordSchema,
  IChangePasswordFormValues,
} from 'FeatureModules/Auth/schemas/auth.schemas';
import { useFirebase } from 'FeatureModules/Auth/Contexts/FirebaseContext';
import { FieldWrapper, ThemeButton } from 'DesignSystem';
import { Field, Form, Formik, FormikProps } from 'formik';
import React, { FC, useRef } from 'react';

const PasswordResetForm: FC = () => {
  const formRef = useRef<FormikProps<IChangePasswordFormValues>>(null);
  const { setErrorMessage, setSuccessMessage } = useMessages();

  const { changePassword } = useFirebase();

  const handleUpdatePassword = async (values: IChangePasswordFormValues) => {
    try {
      await changePassword(values.oldPassword, values.newPassword);
      formRef.current?.resetForm();
      setSuccessMessage('Your password has been changed successfully.');
    } catch (error: unknown) {
      if (error instanceof Error) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage('An unexpected error occurred.');
      }
    }
  };

  return (
    <Formik
      innerRef={formRef}
      validateOnChange
      validationSchema={changePasswordSchema}
      initialValues={changePasswordSchema.default()}
      onSubmit={handleUpdatePassword}
    >
      {({ isSubmitting, isValid }) => (
        <Form>
          <Grid container>
            <Grid item xs={6}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FieldWrapper label="Current Password">
                    <Field fullWidth name="oldPassword" component={PasswordInputField} />
                  </FieldWrapper>
                </Grid>
                <Grid item xs={12}>
                  <FieldWrapper label="New Password">
                    <Field fullWidth name="newPassword" component={PasswordInputField} />
                  </FieldWrapper>
                </Grid>
                <Grid item xs={12}>
                  <FieldWrapper label="Confirm new Password">
                    <Field fullWidth name="confirmNewPassword" component={PasswordInputField} />
                  </FieldWrapper>
                </Grid>
                <Grid item xs={12} justifyContent="flex-end" alignItems="center">
                  <ThemeButton
                    disabled={!isValid}
                    loading={isSubmitting}
                    size="large"
                    color="PRIMARY"
                    type="submit"
                  >
                    Update Password
                  </ThemeButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default PasswordResetForm;
